import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Home from '../components/home/homeIndex';
import Flows from '../components/flows/flows';
import Stores from '../components/stores/storesIndex';
import Restaurants from '../components/restaurants/restaurantsIndex'; /** feature#2 */
import NotFoundPage from '../components/common/notFoundPage';


function routes(){
    return(
        <Router>
            <Switch>
            <Route exact path='/' component={Home}/>
            <Route exact path='/flows' component={Flows}/>
            <Route exact path='/stores' component={Stores}/>
            <Route exact path='/restaurants' component={Restaurants}/>
            <Route component={NotFoundPage}/>
            </Switch>
        </Router>
    )
}

export default routes;